import { AssignmentCard } from './AssignmentCard'
import type { AssignmentWithDetails } from '../../services'

interface AssignmentListProps {
  assignments: AssignmentWithDetails[]
  isLoading?: boolean
  onCancelAssignment?: (assignment: AssignmentWithDetails) => void
  onCompleteAssignment?: (assignment: AssignmentWithDetails) => void
  emptyMessage?: string
}

export function AssignmentList({
  assignments,
  isLoading = false,
  onCancelAssignment,
  onCompleteAssignment,
  emptyMessage = 'No assignments found',
}: AssignmentListProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="bg-gray-200 rounded-xl h-48" />
          </div>
        ))}
      </div>
    )
  }

  if (assignments.length === 0) {
    return (
      <div className="text-center py-12">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
          />
        </svg>
        <p className="mt-4 text-gray-600">{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {assignments.map((assignment) => (
        <AssignmentCard
          key={assignment.id}
          assignment={assignment}
          onCancel={
            onCancelAssignment
              ? () => onCancelAssignment(assignment)
              : undefined
          }
          onComplete={
            onCompleteAssignment
              ? () => onCompleteAssignment(assignment)
              : undefined
          }
        />
      ))}
    </div>
  )
}
